declare global {
  interface Window {
    __consentMetricsLoaded?: Record<string, boolean>;
  }
}

export type MetricsPreset =
  | "default"
  | "mainSite";
type ScriptTarget = "head" | "body";

const loadedState = (window.__consentMetricsLoaded ||= {});

function appendInlineScript(code: string, target: ScriptTarget = "body") {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.text = code;

  if (target === "head") {
    document.head.appendChild(script);
  } else {
    document.body.appendChild(script);
  }
}

function runSnippetOnce(
  key: string,
  code: string,
  target: ScriptTarget = "body",
) {
  if (loadedState[key]) {
    return;
  }

  appendInlineScript(code, target);
  loadedState[key] = true;
}

export function runYandexMetrikaSnippet() {
  runSnippetOnce(
    "yandex-metrika",
    `(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

ym(42095429, "init", {
     clickmap:true,
     trackLinks:true,
     accurateTrackBounce:true,
     webvisor:true,
     trackHash:true,
     ecommerce:"dataLayer"
});`,
  );
}

export function runYandexMetrikaTimeOnSiteGoalSnippet() {
  runSnippetOnce(
    "yandex-metrika-timeonsite-goal",
    `(function()
{
  var sendTimeOnSiteGoal = function()
  {
    setTimeout(function()
    {
      ym(42095429, 'reachGoal', 'timeonsite');
      return true;
    }, 60000)
  };

  if (document.readyState === 'loading')
  {
    document.addEventListener("DOMContentLoaded", function(event)
    {
      sendTimeOnSiteGoal();
    });
  }
  else
  {
    sendTimeOnSiteGoal();
  }
})();`,
  );
}

export function runTopMail3332099Snippet() {
  runSnippetOnce(
    "top-mail-3332099",
    `var _tmr = window._tmr || (window._tmr = []);
_tmr.push({id: "3332099", type: "pageView", start: (new Date()).getTime()});
(function (d, w, id) {
  if (d.getElementById(id)) return;
  var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;
  ts.src = "https://top-fwz1.mail.ru/js/code.js";
  var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};
  if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
})(document, window, "tmr-code");`,
  );
}

export function runTopMail3538927Snippet() {
  runSnippetOnce(
    "top-mail-3538927",
    `var _tmr = window._tmr || (window._tmr = []);
_tmr.push({id: "3538927", type: "pageView", start: (new Date()).getTime()});
(function (d, w, id) {
  if (d.getElementById(id)) return;
  var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;
  ts.src = "https://top-fwz1.mail.ru/js/code.js";
  var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};
  if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
})(document, window, "tmr-code");`,
  );
}

export function runFacebook1732191123724950Snippet() {
  runSnippetOnce(
    "facebook-1732191123724950",
    `!function( f, b, e, v, n, t, s )
{
  if(f.fbq)return;
  n=f.fbq=function()
  {
    n.callMethod?
      n.callMethod.apply(n, arguments):n.queue.push(arguments)
  };
  if(!f._fbq) f._fbq=n;
  n.push=n;
  n.loaded= !0;
  n.version='2.0';
  n.queue=[];
  t=b.createElement(e);
  t.async= !0;
  t.src=v;
  s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s)
}(window, document, 'script',
  'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '1732191123724950');
fbq('track', 'PageView');`,
  );
}

export function runFacebook471006560997286Snippet() {
  runSnippetOnce(
    "facebook-471006560997286",
    `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window,document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '471006560997286');
fbq('track', 'PageView');`,
  );
}

export function runFacebook326325599743321Snippet() {
  runSnippetOnce(
    "facebook-326325599743321",
    `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '326325599743321');
fbq('track', 'PageView');`,
  );
}

export function runFacebook1279097409877377Snippet() {
  runSnippetOnce(
    "facebook-1279097409877377",
    `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                                    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '1279097409877377');
fbq('track', 'PageView');`,
  );
}

// export function runGoogleTagManagerSnippet() {
//   runSnippetOnce(
//     "gtm",
//     `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
// new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
// j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
// 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
// })(window,document,'script','dataLayer','GTM-PSJFQFX');`,
//     "head",
//   );
// }

// export function runGoogleAnalyticsSnippet() {
//   runSnippetOnce(
//     "google-analytics",
//     `(function( i, s, o, g, r, a, m )
// {
//   i['GoogleAnalyticsObject']=r;
//   i[r]=i[r]||function()
//     {
//       (i[r].q=i[r].q||[]).push(arguments)
//     }, i[r].l=1*new Date();
//   a=s.createElement(o),
//     m=s.getElementsByTagName(o)[0];
//   a.async=1;
//   a.src=g;
//   m.parentNode.insertBefore(a, m)
// })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

// ga('create', 'UA-90344615-1', 'auto');
// ga('send', 'pageview');`,
//   );
// }

// export function runGoogleAdsSnippet() {
//   runSnippetOnce(
//     "google-ads",
//     `goog_snippet_vars = function() {
//   var w = window;
//   w.google_conversion_id = 989590235;
//   w.google_conversion_label = "w8boCKS0lnAQ2-Xv1wM";
//   w.google_remarketing_only = false;
// }
// goog_report_conversion = function(url) {
//   goog_snippet_vars();
//   window.google_conversion_format = "3";
//   var opt = new Object();
//   opt.onload_callback = function() {
//     if (typeof(url) != 'undefined') {
//     }
//   }
//   var conv_handler = window['google_trackConversion'];
//   if (typeof(conv_handler) == 'function') {
//     conv_handler(opt);
//   }
// }`,
//   );

//   runSnippetOnce(
//     "google-ads-script",
//     `(function() {
//   var s = document.createElement('script');
//   s.type = 'text/javascript';
//   s.async = true;
//   s.src = '//www.googleadservices.com/pagead/conversion_async.js';
//   var p = document.getElementsByTagName('script')[0];
//   p.parentNode.insertBefore(s, p);
// })();`,
//   );
// }

// export function runVk364386Snippet() {
//   runSnippetOnce(
//     "vk-364386",
//     `!function(){var t=document.createElement("script");t.type="text/javascript",t.async=!0,t.src="https://vk.com/js/api/openapi.js?160",t.onload=function(){VK.Retargeting.Init("VK-RTRG-364386-akq4v"),VK.Retargeting.Hit()},document.head.appendChild(t)}();`,
//   );
// }

// export function runVk1904654Snippet() {
//   runSnippetOnce(
//     "vk-1904654",
//     `!function(){var t=document.createElement("script");t.type="text/javascript",t.async=!0,t.src='https://vk.com/js/api/openapi.js?173',t.onload=function(){VK.Retargeting.Init("VK-RTRG-1904654-677hH"),VK.Retargeting.Hit()},document.head.appendChild(t)}();`,
//   );
// }

// export function runOptinMonsterSnippet() {
//   runSnippetOnce(
//     "optinmonster",
//     `(function(d,u,ac){var s=d.createElement('script');s.type='text/javascript';s.src='https://a.omappapi.com/app/js/api.min.js';s.async=true;s.dataset.user=u;s.dataset.account=ac;d.getElementsByTagName('head')[0].appendChild(s);})(document,183362,198229);`,
//   );
// }

const presetMap: Record<MetricsPreset, Array<() => void>> = {
  default: [
    runYandexMetrikaSnippet,
    runTopMail3332099Snippet,
    runTopMail3538927Snippet,
    runFacebook1732191123724950Snippet,
    runFacebook471006560997286Snippet,
    runFacebook326325599743321Snippet,
    // runGoogleAnalyticsSnippet,
    // runGoogleAdsSnippet,
    // runVk364386Snippet,
    // runVk1904654Snippet,
    // runOptinMonsterSnippet,
  ],
  mainSite: [
    runFacebook1279097409877377Snippet,
    runYandexMetrikaSnippet,
    runTopMail3332099Snippet,
    runYandexMetrikaTimeOnSiteGoalSnippet,
    // runVk364386Snippet,
    // runVk1904654Snippet,
  ],
};

export function loadAcceptedMetricsForPage(preset: MetricsPreset) {
  const metrics = presetMap[preset] || presetMap.default;

  metrics.forEach((run) => run());
}
